<div class="simple-form-aligner billing-aligner">
  <mat-card class="simple-form-card">
    <mat-card-content>
      <h1>Billing</h1>
      <form (ngSubmit)="submit()" autocomplete="on">
        <fieldset [disabled]="waiting">
          <div class="dual-column">
            <div>
              <h2>Subscription settings</h2>

              <div *ngIf="state === 'loading'">
                <mat-spinner diameter="48"></mat-spinner>
              </div>

              <div *ngIf="state === 'error'">
                <p>
                  There was an error loading subscription data. Please check
                  that you have admin access, check your internet connection and
                  try again.
                </p>
              </div>

              <div *ngIf="state === 'ready' && editProductSubscription">
                <p>Active users: {{ activeUserCount }}</p>
                <mat-radio-group
                  aria-label="Select a subscription period"
                  [(ngModel)]="intervalSelected"
                  name="interval"
                >
                  <mat-radio-button
                    [value]="'month'"
                    [checked]="intervalSelected === 'month'"
                  >
                    Monthly: {{ currencyString }}{{ pricePerUserPerMonth }} per
                    user per month
                  </mat-radio-button>
                  <mat-radio-button
                    [value]="'year'"
                    [checked]="intervalSelected === 'year'"
                  >
                    Yearly: {{ currencyString }}{{ pricePerUserPerYear }} per
                    user per year (save 16%)
                  </mat-radio-button>
                </mat-radio-group>

                <div>
                  <h3>
                    Total: {{ currencyString
                    }}{{
                      (intervalSelected === 'month'
                        ? pricePerUserPerMonth
                        : pricePerUserPerYear) * activeUserCount
                    }}
                    per
                    {{ intervalSelected }}
                  </h3>
                </div>

                <p
                  *ngIf="
                    existingProductSubscription &&
                    existingProductSubscription.interval === 'month' &&
                    intervalSelected === 'year'
                  "
                >
                  Your card will be charged immediately (less any credits for
                  remaining time in this billing period).
                </p>
              </div>

              <div *ngIf="state === 'ready' && !editProductSubscription">
                <div *ngIf="existingProductSubscription">
                  <div>
                    Active users: {{ existingProductSubscription.quantity }}
                  </div>
                  <div>
                    Charged {{ existingProductSubscription.interval }}ly
                  </div>
                  <div>
                    Subscription start:
                    {{ existingProductSubscription.startDateString }}
                  </div>
                  <div *ngIf="existingProductSubscription.cancelDateString">
                    Subscription end:
                    {{ existingProductSubscription.cancelDateString }}
                  </div>
                  <h3>
                    Total: {{ currencyString
                    }}{{
                      (intervalSelected === 'month'
                        ? pricePerUserPerMonth
                        : pricePerUserPerYear) * activeUserCount
                    }}
                    per
                    {{ intervalSelected }}
                  </h3>
                  <div *ngIf="!existingProductSubscription.cancelDateString">
                    <button
                      type="button"
                      mat-stroked-button
                      color="primary"
                      (click)="editProductSubscription = true"
                    >
                      Edit
                    </button>
                    &nbsp;
                    <button
                      *ngIf="!existingProductSubscription.cancelDateString"
                      type="button"
                      mat-stroked-button
                      color="warn"
                      (click)="launchCancelDialog()"
                    >
                      Cancel my subscription
                    </button>
                  </div>

                  <div *ngIf="creditCard">
                    <h2>Card details</h2>
                    <p>
                      {{
                        creditCard.brand[0].toUpperCase() +
                          creditCard.brand.slice(1)
                      }}
                      •••• {{ creditCard.last4 }} <br />
                      Expires:
                      {{ creditCard.expMonth.toString().padStart(2, '0') }}/{{
                        creditCard.expYear.toString().slice(2)
                      }}
                    </p>
                    <button
                      type="button"
                      mat-stroked-button
                      color="primary"
                      (click)="updateCreditCard()"
                    >
                      Update credit card
                    </button>
                  </div>
                </div>

                <div *ngIf="!existingProductSubscription">
                  <p>You don't have any current subscriptions.</p>

                  <p *ngIf="org.subscription.status === 'free-country'">
                    As we don't have billing in your country yet, please enjoy
                    free access until we get billing set up for your country.
                  </p>

                  <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="editProductSubscription = true"
                  >
                    Buy a subscription
                  </button>
                </div>
              </div>
            </div>

            <div>
              <h2>Billing details</h2>

              <div *ngIf="state === 'ready' && editBillingDetails">
                <div class="form-group">
                  This account is a:
                  <mat-radio-group
                    aria-label="Select business or individual"
                    [(ngModel)]="isBusiness"
                    (ngModelChange)="onSetBusiness($event)"
                    name="isBusiness"
                  >
                    <mat-radio-button [value]="true" [checked]="isBusiness">
                      Business
                    </mat-radio-button>
                    <mat-radio-button [value]="false" [checked]="!isBusiness">
                      Individual
                    </mat-radio-button>
                  </mat-radio-group>

                  <mat-form-field
                    class="simple-form-field-100"
                    floatLabel="always"
                  >
                    <mat-label>{{
                      isBusiness ? 'Company name for invoice' : 'Billing name'
                    }}</mat-label>
                    <input
                      [formControl]="name"
                      matInput
                      type="text"
                      name="name"
                      id="name"
                      autocomplete="name"
                      required
                    />
                    <mat-error>Required</mat-error>
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="collectTaxId"
                    class="simple-form-field-100"
                    floatLabel="always"
                  >
                    <mat-label>{{ taxIdName }}</mat-label>
                    <input
                      [formControl]="taxId"
                      matInput
                      type="text"
                      name="taxId"
                      id="taxId"
                      required
                    />
                    <mat-error>Required</mat-error>
                  </mat-form-field>

                  <div>
                    <mat-checkbox
                      *ngIf="!isBusiness"
                      class="example-margin"
                      [(ngModel)]="setIndividualAddress"
                      name="setIndividualAddress"
                    >
                      Add billing address to invoice
                    </mat-checkbox>
                  </div>

                  <ng-container *ngIf="isBusiness || setIndividualAddress">
                    <mat-form-field
                      class="simple-form-field-100"
                      [floatLabel]="'always'"
                    >
                      <mat-label>Billing email</mat-label>
                      <input
                        [formControl]="email"
                        matInput
                        type="text"
                        name="email"
                        autocomplete="email"
                        required
                      />
                      <mat-error>Not a valid email</mat-error>
                    </mat-form-field>

                    <mat-form-field
                      class="simple-form-field-100"
                      floatLabel="always"
                    >
                      <mat-label>Address 1</mat-label>
                      <input
                        [formControl]="address1"
                        matInput
                        type="text"
                        name="address-line1"
                        id="address1"
                        autocomplete="address-line1"
                        required
                      />
                      <mat-error>Required</mat-error>
                    </mat-form-field>

                    <mat-form-field
                      class="simple-form-field-100"
                      floatLabel="always"
                    >
                      <mat-label>Address 2</mat-label>
                      <input
                        [formControl]="address2"
                        matInput
                        type="text"
                        name="address-line2"
                        id="address2"
                        autocomplete="address-line2"
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="simple-form-field-100"
                      floatLabel="always"
                    >
                      <mat-label>City</mat-label>
                      <input
                        [formControl]="city"
                        matInput
                        type="text"
                        name="city"
                        id="city"
                        autocomplete="address-level2"
                        required
                      />
                      <mat-error>Required</mat-error>
                    </mat-form-field>

                    <mat-form-field
                      class="simple-form-field-100"
                      *ngIf="subRegions"
                    >
                      <mat-label>State</mat-label>
                      <mat-select
                        [formControl]="subRegionControl"
                        name="subRegion"
                        (selectionChange)="subRegionSelected()"
                      >
                        <mat-option
                          *ngFor="let s of subRegions"
                          [value]="s.code"
                        >
                          {{ s.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error>State not selected.</mat-error>
                    </mat-form-field>

                    <mat-form-field
                      class="simple-form-field-100"
                      floatLabel="always"
                    >
                      <mat-label>{{ postalCodeName }}</mat-label>
                      <input
                        [formControl]="postalCode"
                        matInput
                        type="text"
                        name="postal-code"
                        id="postal-code"
                        autocomplete="postal-code"
                        required
                      />
                      <mat-error>Required</mat-error>
                    </mat-form-field>
                  </ng-container>

                  <mat-form-field class="simple-form-field-100">
                    <mat-label>Country</mat-label>
                    <input
                      [formControl]="countryControl"
                      type="text"
                      #countryInput
                      matInput
                      [matAutocomplete]="countryAutocomplete"
                      (blur)="blurCountrySelected()"
                    />
                    <mat-autocomplete
                      autoActiveFirstOption
                      #countryAutocomplete="matAutocomplete"
                      [displayWith]="countryDisplay"
                      (optionSelected)="countrySelected($event)"
                    >
                      <mat-option
                        *ngFor="let option of filteredCountries | async"
                        [value]="option"
                      >
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error>Country not selected.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                *ngIf="
                  state === 'ready' && !editBillingDetails && existingBilling
                "
              >
                <p>
                  <b>Account type:</b>
                  {{ existingBilling.isBusiness ? 'Business' : 'Individual' }}
                </p>
                <p *ngIf="existingBilling.tax">
                  <b>{{ taxIdName }}:</b>
                  {{ existingBilling.tax.value }}
                </p>
                <p>
                  <b>Billing address:</b><br />
                  <ng-container *ngIf="existingBilling.address">
                    {{ existingBilling.address.line1 ?? '' }} <br />
                    <ng-container *ngIf="existingBilling.address.line2">
                      {{ existingBilling.address.line2 }}
                      <br />
                    </ng-container>
                    {{ existingBilling.address.city ?? '' }} <br />
                    {{ existingBilling.address.state ?? '' }}
                    {{ existingBilling.address.postalCode ?? '' }} <br />
                    {{ existingBilling.countryCode ?? '' }} <br />
                  </ng-container>
                </p>
                <button
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="showEditBilling()"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              state === 'ready' &&
              (editBillingDetails || editProductSubscription)
            "
            class="button-right-container"
          >
            <div></div>
            <div>
              <div class="spinner-container" *ngIf="waiting">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
              <div>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="waiting || disableSubmit"
                  type="submit"
                  value="submit"
                >
                  {{
                    existingProductSubscription
                      ? 'Save billing information'
                      : 'Checkout'
                  }}
                </button>
              </div>
            </div>
          </div>
          <span *ngIf="formErrorMessage" class="text-error-color">
            {{ formErrorMessage }}
          </span>
        </fieldset>
      </form>

      <div
        *ngIf="
          !editBillingDetails && !editProductSubscription && charges.length
        "
      >
        <h2>Invoices</h2>
        <table mat-table [dataSource]="charges" class="mat-elevation-z8">
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element">{{ element.date }}</td>
          </ng-container>

          <!-- Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let element">
              {{ element.amountString }}
            </td>
          </ng-container>

          <!-- Invoice Column -->
          <ng-container matColumnDef="invoice">
            <th mat-header-cell *matHeaderCellDef>Invoice</th>
            <td mat-cell *matCellDef="let element">
              <a href="{{ element.receiptUrl }}" class="text-link"
                >Download invoice</a
              >
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="chargesColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: chargesColumns"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
